import environment from './environment';
import * as FullStory from '@fullstory/browser';

let isInitialized = false;
export function initializeFullstory() {
    if (isInitialized) return;

    if (environment.fullstoryOrgId) {
        FullStory.init({ orgId: environment.fullstoryOrgId as string });
    }

    isInitialized = true;
}
